export default __webpack_public_path__ + "media/images/images/flags/co-01afd1944e33cda66f4397d2f0669237.png";